import AnimateWhenCurrencyChange from 'containers/AnimateWhenCurrencyChange'

import ProviderTileContainer from '../ProviderTileContainer'

import classes from './styles.module.scss'

import type { Provider } from '@patrianna/shared-patrianna-types/store/ProviderModule'

type Props = {
  providers: Provider[]
}

function Providers(props: Props) {
  if (!props.providers?.length) {
    return null
  }

  return (
    <div className={classes.root}>
      <AnimateWhenCurrencyChange className={classes.tileContainer} disabledAtTime={2000}>
        {props.providers.map((provider) => (
          <ProviderTileContainer provider={provider} className={classes.item} key={provider.code} />
        ))}
      </AnimateWhenCurrencyChange>
    </div>
  )
}

export default Providers
